module.exports = __webpack_public_path__ + "pc/img/icon3.537b2ddf.png";